import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { Announcement } from '@pets-ui/Icons'
import { Image } from '@pets-ui/Image/Image'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'
import { VStack } from '@pets-ui/VStack/VStack'
import bannerBgMobile from '../../assets/new-products-banner-bg-mobile.png'
import bannerBgDesktop from '../../assets/new-products-banner-bg.png'

export const NewProductsBanner = () => {
  const isMobile = useResponsive('mobile')

  return (
    <Box position="relative" borderRadius={8} overflow="hidden" height={80}>
      <Image src={isMobile ? bannerBgMobile : bannerBgDesktop} alt="New Products Banner" width="100%" height={80} objectFit="cover" />
      <VStack position="absolute" top={0} left={0} right={0} bottom={0} gap={1} alignItems="center" justifyContent="center">
        <HStack gap={1} alignItems="center">
          <Announcement fontSize={18} />
          <Text variant="h4" color={colors.white}>新貨到！</Text>
        </HStack>
        <Text color={colors.white}>搶先同行上架，贏得市場先機</Text>
      </VStack>
    </Box>
  )
}
